import ManagementStack from './ManagementStack';

export default ManagementStack;
